import React, { useCallback, useLayoutEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import NotFound from "pages/common/notFound";
import RealtimeList from "components/realtime/realtimeList";
import RealtimeDetail from "components/realtime/realtimeDetail";
import CmsDetail from "components/realtime/cmsDetail";

function Realtime() {
  const [render, setRender] = useState(<></>);
  const location = useLocation();
  const meetingKey =
    location.state?.MEETING_KEY === undefined
      ? ""
      : location.state?.MEETING_KEY;
  const schedueType =
    location.state?.SCHEDULE_TYPE === undefined
      ? ""
      : location.state?.SCHEDULE_TYPE;
  const scheduleId =
    location.state?.SCHEDULE_ID === undefined
      ? ""
      : location.state?.SCHEDULE_ID;
  const serverNo =
    location.state?.SERVER_NO === undefined ? "" : location.state?.SERVER_NO;

  const pageRender = useCallback(() => {
    if (meetingKey === "" && schedueType === "") {
      setRender(<RealtimeList />);
    } else {
      switch (schedueType) {
        case "CD0203":
          setRender(
            <CmsDetail
              meetingKey={meetingKey}
              schedueType={schedueType}
              serverNo={serverNo}
            />
          );
          break;
        case "CD0204":
          setRender(
            <RealtimeDetail
              meetingKey={meetingKey}
              schedueType={schedueType}
              scheduleId={scheduleId}
            />
          );
          break;
        default:
          setRender(<NotFound />);
          break;
      }
    }
  }, [meetingKey, scheduleId, schedueType]);

  useLayoutEffect(() => {
    pageRender();
  }, [pageRender]);

  return (
    <>
      <Routes>
        <Route path="/" element={render} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default Realtime;
